import { render, staticRenderFns } from "./CV.vue?vue&type=template&id=31a8ed52&scoped=true"
import script from "./CV.vue?vue&type=script&lang=js"
export * from "./CV.vue?vue&type=script&lang=js"
import style0 from "./CV.vue?vue&type=style&index=0&id=31a8ed52&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a8ed52",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/myskilliz_new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31a8ed52')) {
      api.createRecord('31a8ed52', component.options)
    } else {
      api.reload('31a8ed52', component.options)
    }
    module.hot.accept("./CV.vue?vue&type=template&id=31a8ed52&scoped=true", function () {
      api.rerender('31a8ed52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/divers/CV.vue"
export default component.exports